import React from 'react';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';
import { ISonURL } from '../../../../types/IUrl';

type PhoneLink = {
  phoneLink: ISonURL;
  dfn: string;
  title: string;
};

export function PhoneLink({ phoneLink, dfn, title }: PhoneLink) {
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      <Hyperlink routing={false} to={phoneLink.url} className="personal-data__link" title={title}>
        {phoneLink.name}
      </Hyperlink>
    </p>
  );
}
